export default __webpack_public_path__ + "static/media/image-check.092e8b15.svg";